import axiosSetup from "../utils/axiosSetup";

export const fetchBirthAndWorkAnniversaryApi = async ({
  month,
  year,
}: {
  month: number;
  year: number;
}) => {
  try {
    const res = await axiosSetup.get("/hr/birth-work-anniversary", {
      params: { month, year },
    });
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUpcomingConfirmationsApi = async () => {
  try {
    const res = await axiosSetup.get("/hr/employee-confirmations");
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const confirmEmployeeApi = async (payload: any) => {
  try {
    const res = await axiosSetup.post("/hr/confirm-employee", payload);
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const extendProbationApi = async (payload: any) => {
  try {
    const res = await axiosSetup.post("/hr/extend-probation", payload);
    return res.data.data;
  } catch (error) {
    throw error;
  }
};